import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import config from '@app/config'
import { User } from '@app/models'
import { AppDispatch } from '@app/store'
import { syncCurrentUser } from '@app/store/user'

import { logger } from '@lib/utils'

import { StorageEvents } from './constants'

export const useSyncStorage = () => {
  const dispatch: AppDispatch = useDispatch()

  const handleStorageChange = (event: StorageEvent) => {
    switch (event.key as StorageEvents) {
      case StorageEvents.CURRENT_USER: {
        if (event.newValue) {
          try {
            const user: User = JSON.parse(event.newValue)
            config.regionalSettings = user.regionalSettings || {}
            dispatch(syncCurrentUser(user))
          } catch (error) {
            logger(`Sync: ${StorageEvents.CURRENT_USER}`, error)
          }
        }

        break
      }

      default: {
        return null
      }
    }
  }

  useEffect(() => {
    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])
}
